import { FieldAttributes, useField } from 'formik';
import React from 'react';
import { Form, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  default as NumberFormat,
  NumberFormatProps,
} from 'react-number-format';
import { FieldFeedback } from '.';
import FieldTooltip from './field-tooltip';
import { FieldLabel } from '../forms';

const CustomInput = (props) => (
  <Form.Control
    {...props}
    style={{
      ...(props.required && !props.disabled
        ? { backgroundColor: 'lightYellow' }
        : {}),
      ...(props.prefixLabel ? { borderLeftWidth: '0' } : {}),
      ...(props.suffixLabel ? { borderRightWidth: '0' } : {}),
    }}
    isInvalid={props.isInvalid}
  />
);

//<<<<<<<<<<<<<<< ---------------------------------------------------- >>>>>>>>
//<<<<<<<<<<<<<<<               FieldNumberFormat Component                    >>>>>>>>
//<<<<<<<<<<<<<<< ---------------------------------------------------- >>>>>>>>
type Props = {
  as?: React.ElementType<any>;
  label: string;
  required?: boolean;
  prefixLabel?: string;
  prefixWidth?: string;
  suffixLabel?: string;
  suffixWidth?: string;
  changed?: boolean;
  tooltip?: string;
} & Partial<FieldAttributes<NumberFormatProps>>;

const FieldNumberFormat = ({
  as = 'div',
  decimalScale = 2,
  //fixedDecimalScale = true,
  prefixLabel,
  prefixWidth = '7rem',
  suffixLabel,
  suffixWidth = '2rem',
  ...rest
}: Props) => {
  const [field, meta, helpers] = useField<number>(rest.name);
  return (
    //@ts-ignore
    <Form.Group as={as} controlId={rest.name} className="mb-2">
      {rest.label && (
        <FieldLabel
          text={rest.label}
          changed={rest.changed}
          required={rest.required}
        />
      )}
      <OverlayTrigger
        delay={{ show: 1000, hide: 200 }}
        overlay={
          rest.type === 'password' ? (
            <Tooltip id="password-tooltip">{rest.tooltip}</Tooltip>
          ) : (
            <FieldTooltip text={rest.name} value={rest.value || ''} />
          )
        }
        placement="top"
      >
        <InputGroup>
          {prefixLabel && (
            <InputGroup.Text
              style={{
                borderTopRightRadius: '0',
                borderBottomRightRadius: '0',
                width: prefixWidth,
              }}
            >
              {prefixLabel}
            </InputGroup.Text>
          )}
          <NumberFormat
            onChange={rest.onChange}
            autoComplete={'off'}
            name={rest.name}
            thousandSeparator={'.'}
            decimalSeparator={','}
            decimalScale={decimalScale}
            //fixedDecimalScale={fixedDecimalScale}
            displayType={'input'}
            allowNegative={false}
            onValueChange={({ floatValue }) =>
              floatValue === undefined
                ? helpers.setValue(null)
                : helpers.setValue(floatValue)
            }
            value={field.value === undefined ? null : field.value}
            customInput={CustomInput}
            disabled={rest.disabled}
            required={rest.required}
            isInvalid={meta.touched && !!meta.error}
            suffixLabel={suffixLabel}
            prefixLabel={prefixLabel}
          />
          {suffixLabel && (
            <InputGroup.Text
              style={{
                borderTopLeftRadius: '0',
                borderBottomLeftRadius: '0',
                width: suffixWidth,
              }}
            >
              {suffixLabel}
            </InputGroup.Text>
          )}
        </InputGroup>
      </OverlayTrigger>
      <FieldFeedback type="invalid" name={rest.name} />
    </Form.Group>
  );
};

export default FieldNumberFormat;
